import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket'
import { SocketMessage, SocketMessageType } from '../models/websockets';
import { NotificationService } from './notification.service';
import { MessagingService } from '../messages/messaging.service';
import { WhatsappService } from '../whatsapp/whatsapp.service';
import { environment } from 'src/environments/environment';
import { PhoneCallCustomer } from '../models/call';
import { NzNotificationRef } from 'ng-zorro-antd/notification';
import { PosService } from '../pos/pos.service';
import { AuthService } from '../auth.service';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { PhonecallService } from './phonecall.service';


@Injectable({
  providedIn: 'root'
})
export class WebsocketsService {

  public salesCount = 0;
  public leadsCount = 0;
  public purchasesCount = 0;

  public callNotificationsEnabled: boolean =
    localStorage.getItem('callNotificationsEnabled') !== 'false';
  url: string;

  public setCallNotificationsEnabled(value: boolean): void {
    this.callNotificationsEnabled = value;
    localStorage.setItem('callNotificationsEnabled', value.toString());
  }

  public messages: Subject<SocketMessage>;
  public fleetPosUpdated = new Subject<number>();

  private activeCallNotifications = new Map<number, NzNotificationRef>();
  private activeCallTimeouts = new Map<number, ReturnType<typeof setTimeout>>();
  private activeQuoteActionNotifications = new Map<number, Set<NzNotificationRef>>();

  constructor(private notification: NotificationService, private messageService: MessagingService, private waService: WhatsappService, private posService: PosService, private authService: AuthService, private router: Router, private phonecallService: PhonecallService) { }

  public connect(url): Subject<SocketMessage> {
    this.messages = webSocket(url);
    console.log("[WS] Connected to ", url); //Leave this log statement to see if we connect to WS Hub, so we know if we have connection or not
    return this.messages;
  }

  //TO SEND A MESSAGE, ANYWHERE IN CODE:
  // let retmsg = new SocketMessage();
  // retmsg.type = 1;
  // retmsg.value = '3';
  // retmsg.message = "Hello World"
  // this.websockets.SendMessage(retmsg);
  public SendMessage(msg: SocketMessage) {
    this.messages.next(msg);
  }

  public MessageObservable(): Observable<SocketMessage> {
    return this.messages.asObservable();
  }

  public HandleMessage(msg: SocketMessage) {
    if (msg.type == SocketMessageType.BlockingPopup) {
      this.notification.ShowBlockingPopup(msg.message);

    }
    else if (msg.type == SocketMessageType.ClickablePopup){
        this.notification.showClickableMessageNotification(
        'New Message - Click to View',
        msg.message,
        msg.action1Url? msg.action1Url : '' //pass messageUuid here to open specific message
      );
    }
    else if (msg.type == SocketMessageType.PopUp) {
      this.notification.ShowNonBlockingMessage(msg.message);
    }
    else if (msg.type == SocketMessageType.SilentNotification || msg.type == SocketMessageType.SilentMessage)
    {
      // this.messageService.getUreadMessages(15).subscribe(res => {
      // })
      this.messageService.addMessage(msg);

    }
    else if (msg.type == SocketMessageType.SilentRefreshInbox) {
      this.messageService.getUnreadMessages(15).subscribe(
        _ => {}
      )
    }
    else if (msg.type == SocketMessageType.ReadInboxMessage) {
      this.messageService.markGroupIdAsRead(msg.value);
    }
    else if (msg.type == SocketMessageType.ForceLogout) {
      //from app.component - move to shared location
      localStorage.removeItem("clientData");
      localStorage.removeItem("access_token");
      sessionStorage.clear();
      location.reload();
    }
    else if (msg.type == SocketMessageType.LeadsCount) {
      this.leadsCount = +msg.value;
    }
    else if (msg.type == SocketMessageType.SalesCount) {
      this.salesCount = +msg.value;
    }
    else if (msg.type == SocketMessageType.SilentRefreshWhatsApp) {
      this.waService.RefreshAll()
    }
    else if (msg.type == SocketMessageType.LoadPopUpMessage) {      
      if (!isNaN(Number(msg.value))) {
        this.messageService.getMessageById(Number(msg.value)).subscribe({
          next: val => {
            this.notification.ShowBlockingPopup(val.messageLong, val.message, '90%');
            this.messageService.markMessageAsRead(val).subscribe({
              next: _ => {},
              error: err => this.notification.handleErrorSilent(err)
            })
          },
          error: err => {this.notification.handleErrorSilent(err)}
        })
      }
      
    }
    else if (msg.type == SocketMessageType.UpdateLoadBalancing) {
      if (msg.message === "api_url_main") {
        environment.api_url_main = msg.value;
      }
      else if (msg.message === "api_url_alt") {
        environment.api_url_alt = msg.value;
      }
      else if (msg.message === "api_alt_weight") {
        environment.api_alt_weight = +msg.value;
      }
      else if (msg.message === "api_endpoints_setup") {
        let oldValues = environment.apiEndpoints;
        environment.apiEndpoints = JSON.parse(msg.value);
        environment.apiEndpoints.forEach(e => {
          oldValues.forEach(o => {
            if (o.url === e.url) {
              e.isActive = o.isActive;
            }
          })
        });
      }
      
      
    }
    else if (msg.type == SocketMessageType.IncomingCall || msg.type == SocketMessageType.PleaseCallMe) {
      if (this.callNotificationsEnabled) {
        let phoneCallCustomer: PhoneCallCustomer = JSON.parse(msg.value);
        const ref = this.notification.showIncomingCallNotification(phoneCallCustomer, msg.message);
        this.activeCallNotifications.set(phoneCallCustomer.phoneCallId, ref);

        //Add a second layer dismiss, rather use the creation in nitofication service.
        // const timeout = setTimeout(() => this.notification.dismissIncomingCallNotification(ref), 5 * 60 * 1000); // 5 minutes to auto clear the notification if not handled
        // this.activeCallTimeouts.set(phoneCallCustomer.phoneCallId, timeout);

        ref.onClose.subscribe(() => {
          clearTimeout(this.activeCallTimeouts.get(phoneCallCustomer.phoneCallId));
          this.activeCallTimeouts.delete(phoneCallCustomer.phoneCallId);
          this.activeCallNotifications.delete(phoneCallCustomer.phoneCallId);
        });
      }
    }
    else if (msg.type == SocketMessageType.QuoteAction) {
      const quoteId = this.getQuoteIdFromUrl(msg.action1Url);
      const ref = this.notification.showQuoteActionNotification(
        msg.message,
        msg.value || '',
        msg.action1Url || '',
        () => {
          if (quoteId !== null) {
            this.phonecallService.cancelQuoteAction(quoteId).subscribe({
              error: err => this.notification.handleError(
                err, 'Could not dismiss quote-action notifications for other users'
              )
            });
          }
        }
      );
      if (quoteId !== null) {
        const refs = this.activeQuoteActionNotifications.get(quoteId) || new Set<NzNotificationRef>();
        refs.add(ref);
        this.activeQuoteActionNotifications.set(quoteId, refs);
        ref.onClose.subscribe(() => {
          refs.delete(ref);
          if (refs.size === 0 && this.activeQuoteActionNotifications.get(quoteId) === refs) {
            this.activeQuoteActionNotifications.delete(quoteId);
          }
        });
      }
    }
    else if (msg.type == SocketMessageType.QuoteActionCancelled) {
      const quoteId = +msg.value;
      const refs = this.activeQuoteActionNotifications.get(quoteId);
      if (refs) {
        this.activeQuoteActionNotifications.delete(quoteId);
        for (const ref of Array.from(refs)) {
          this.notification.dismissQuoteActionNotification(ref);
        }
      }
    }
    else if (msg.type == SocketMessageType.IncomingCallCancelled) {
      const callId = +msg.value;
      console.log("Received request to cancel call", callId);

      clearTimeout(this.activeCallTimeouts.get(callId));
      this.activeCallTimeouts.delete(callId);

      const ref = this.activeCallNotifications.get(callId);
      if (ref) {
        this.notification.dismissIncomingCallNotification(ref);
        this.activeCallNotifications.delete(callId);
      }
    }
    else if (msg.type == SocketMessageType.UpdateFleetPos) {
      if (msg.userId === this.authService.user?.user_id) {
        this.notification.showClickableNotification(
        "Status for fleet quote: " + msg.value,
        msg.message,
        'pos/v2/' + msg.value
      );
        this.fleetPosUpdated.next(+msg.value);
      }
    }
  }

  private getQuoteIdFromUrl(url: string | null): number | null {
    const match = (url || '').match(/\/pos\/v2\/(\d+)(?:[/?#]|$)/);
    if (!match) {
      return null;
    }
    const quoteId = Number(match[1]);
    return Number.isSafeInteger(quoteId) && quoteId > 0 ? quoteId : null;
  }
}
